import styled from 'styled-components';
import { Element } from 'react-scroll';

const SectionBlock = styled(Element)`
`;

export default SectionBlock;



// WEBPACK FOOTER //
// ./src/layout/SectionBlock.jsx